import styled from 'styled-components'

export const MedicationsSelectContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const SelectedOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  > div:last-child {
    border-bottom: initial;
  }
`

export const SelectedOptionsTitle = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  text-wrap: nowrap;

  margin-top: 10px;

  hr {
    height: 1px;
    width: 100%;

    border: none;

    background-color: #e2e2e2;
  }
`
